import { DiscountType } from "@/constants/discountType"; // adjust path if needed

export const formatDiscount = (value: number, type?: DiscountType): string => {
  if (type === "percentage") {
    return `${value}%`;
  }

  // format to MGA
  return new Intl.NumberFormat("fr-MG", {
    style: "currency",
    currency: "MGA",
    minimumFractionDigits: 0,
  }).format(value);
};
